var map = {
	"./": "13aa",
	"./error-store": "b7c7",
	"./error-store/": "b7c7",
	"./error-store/index": "b7c7",
	"./error-store/index.js": "b7c7",
	"./index": "13aa",
	"./index.js": "13aa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0f29";